import { createSlice } from "@reduxjs/toolkit";
import { getLocalStoragePermissions, getLocalStorageIsManager, getLocalStorageIsClientUser } from "utils/utilityFunctions";

interface AuthStateType {
  accessToken: string;
  permissions: UserPermissionType[];
  is_manager: boolean;
  is_clientUser: boolean;
  loading: boolean;
  loginError: any;
}
export const initialState: AuthStateType = {
  accessToken: "",
  permissions: getLocalStoragePermissions(),
  is_manager: getLocalStorageIsManager(),
  is_clientUser: getLocalStorageIsClientUser(),
  loading: false,
  loginError: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.loginError = initialState.loginError;
      state.accessToken = action.payload.token;
      state.permissions = action.payload.permissions;
      state.is_manager = action.payload.is_manager;
      state.is_clientUser = action.payload.is_clientuser;
    },
    loginFailure(state, action) {
      state.accessToken = initialState.accessToken;
      state.permissions = initialState.permissions;
      state.is_manager = initialState.is_manager;
      state.is_clientUser = initialState.is_clientUser;
      state.loginError = action.payload;
    },
    setAuthLoading(state, action) {
      state.loading = action.payload
    }
}});

export const { loginSuccess, loginFailure, setAuthLoading } = authSlice.actions;

export default authSlice.reducer;
